document.querySelectorAll('.clickable-video').forEach(function (video) {
    video.addEventListener('click', function () {
        if (this.paused || this.ended) this.play();
        else this.pause();
    });
});
